import * as types from './mutation-types'

export default {
    /**
     * 初始化clientID
     */
    initClientId ({commit}, obj) {
        commit(types.INIT_CLIENT_ID, obj)
    },
    /**
     * 更新登录标识
     */
    updateAuthorizd ({commit}, bool) {
        commit(types.UPDATE_AUTHORIZD, bool)
    },
    /**
     * tokon的更新
     */
    updateTokon ({commit}, tokon) {
        commit(types.UPDATE_TOKON, tokon)
    },
    /**
     * 海量发hlf_tokon的更新
     */
    updateHlfTokon ({commit}, hlftokon) {
        
        commit(types.UPDATE_HLFTOKON, hlftokon)
    },
    /**
     * 初始化用户信息
     */
    initUserInfo ({commit}, info) {
        commit(types.INIT_USER_INFO, info)  
    },
    /**
     * 初始化配置文件
     */
    initConfig ({commit}, config) {
        commit(types.INIT_CONFIG, config)
    },
    /**
     * 设置menu的配置
     * @param label menu的唯一标志label
     */
    setCurrMenu ({commit}, label) {
        commit(types.SET_CURR_MENU, label)
    },
    /**
     * 设置当前的页面
     * @param type 页面的类型
     */
    setCurrPage ({commit}, type) {
        commit(types.SET_CURR_PAGE, type)
    },

    /**
     * 2019-10-30 区分显示需要带入的ID
     * @param {*} id 
     */
    setHubbleId ({commit}, id) {
        commit(types.SET_HUBBLE_ID, id)
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js